import * as React from "react";
import { forwardRef } from "react";
const SvgIconEmojiNeutral = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 14, height: 14, viewBox: "0 0 14 14", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M11 4a7 7 0 1 0 7 7 7.01 7.01 0 0 0-7-7m0 1.167A5.833 5.833 0 1 1 5.167 11 5.824 5.824 0 0 1 11 5.167m-2.625 3.5a.875.875 0 1 0 .875.875.875.875 0 0 0-.875-.875m5.25 0a.875.875 0 1 0 .875.875.875.875 0 0 0-.875-.875m-5.542 4.666V14.5h5.833v-1.167z", "data-name": "icon/emoji/neutral", transform: "translate(-4 -4)", fill: "#b6c2d0" }));
const ForwardRef = forwardRef(SvgIconEmojiNeutral);
export { ForwardRef as ReactComponent };
